import { memo } from "react";
import Svg, { Path, type SvgProps } from "react-native-svg";

const SvgBath = (props: SvgProps) => (
  <Svg fill="none" height={24} width={24} {...props}>
    <Path
      clipRule="evenodd"
      d="M4.654 3.016c0-.346.125-.542.278-.669.177-.147.452-.249.771-.249s.594.102.77.249c.153.127.28.323.28.67h.01a4.2 4.2 0 0 0 .961 4.803l.768.716a1.05 1.05 0 0 0 1.482-.052l4.294-4.604a1.05 1.05 0 0 0-.052-1.483l-.767-.715a4.2 4.2 0 0 0-5.159-.445 2.9 2.9 0 0 0-.473-.502C7.207.226 6.434 0 5.703 0S4.199.226 3.589.735c-.635.529-1.034 1.316-1.034 2.281v9.443H1.507a1.05 1.05 0 1 0 0 2.098h1.047v5.246c0 1.159.94 2.098 2.098 2.098h.003v1.05a1.05 1.05 0 1 0 2.098 0V21.9h10.494v1.05a1.05 1.05 0 1 0 2.098 0V21.9a2.1 2.1 0 0 0 2.095-2.098v-5.246h1.05a1.05 1.05 0 1 0 0-2.098H4.655zm4.501 3.27 2.863-3.07a2.098 2.098 0 1 0-2.863 3.07m10.186 8.271H4.652v5.246h14.69z"
      fill={props.color}
      fillRule="evenodd"
    />
  </Svg>
);
const Memo = memo(SvgBath);
export default Memo;
